<template>
  <DialogTemplateToolkit
    class-name="check-additional-fields"
    :data-qa="'check-additional-fields-dialog'"
    :dialog="opened"
    first_btn="AdditionalFields.NewAdditionalField"
    :title="$t('AdditionalFields.CreateField')"
    without_second_btn
    @apply="$emit( 'openCreatingField')"
    @close="$emit( 'close')">
    <template #backBtn>
      <sButton
        v-if="back_step"
        class="bold h7-text px-2"
        data-qa="back-btn"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        small
        type="text"
        @click="$emit( 'back')">
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #card-text>
      <div class="py-2">
        <div
          class="check-additional-fields__subtitle h9-label flex flex-between"
          style="width: 100%;">
          {{ $t('AdditionalFields.SavedCustomizedFields') }}
          <sButton
            v-if="isDeveloper && additional_fields.length"
            class="mr-2 ml-auto my-auto"
            data-qa="delete-all-btn"
            icon="cancel"
            small
            type="text"
            @click="deleteAllFields">
            Delete all
          </sButton>
        </div>
        <transition-group
          class="check-additional-fields__list additional-types-list flex wrap flex-between pa-0 mt-4"
          name="list"
          tag="ul">
          <AdditionalFieldRow
            v-for="(item, index) in additional_fields"
            :key="`${item.id}_${item.caption}_${item.typeId}`"
            :class="[{'mb-2': index != additional_fields.length - 1}, 'additional-types-list__item']"
            :count="additional_fields.length"
            :entity="entity"
            :index="index"
            :item="item"
            @changeOrder="(delta) => changeOrder(item, delta)"
            @deleteField="deleteField"
            @editField="editField"/>
        </transition-group>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import AdditionalFieldRow from 'components/additional fields/AdditionalFieldRow.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { additionalFieldsMixin } from 'mixins'
export default {
  name: 'checkAdditionalFields',
  mixins: [additionalFieldsMixin],
  props: {
    additional_fields: {
      type: Array,
      required: true
    },
    back_step: {
      type: Boolean
    },
    opened: {
      type: Boolean,
    },
    /**
     * Сущность для привязки
     */
    entity: {
      type: Object
    }
  },
  methods: {
    deleteField(item) {
      this.$emit('openDeletingField', item )
    },
    deleteAllFields() {
      this.$emit('openDeletingAllFields')
    },
    editField(item) {
      this.$emit('openEditingField', item )
    },
    changeOrder(item, delta) {
      this.$emit('changeOrder', {item, delta} )
    }
  },
  components: {
    AdditionalFieldRow,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.list-move {
  transition: transform 0.5s;
}
</style>
